import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewChildren,
  ChangeDetectorRef,
} from '@angular/core';
import { SingleNumberPickerComponent } from './single-number-picker.component';
import { DrawOptionInstanceDTO, BetSlipPickedDTO } from '../model/lottomart-model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'display-selected-line',
  template: `
    @for (pick of selections; track pick) {
      <div class="display-single-number-picker">
        @if (drawOption) {
          <single-number-picker
            [pick]="pick"
            [type]="drawOption.shapeType"
            [readonly]="readonly"
            [isDisplayLine]="true"
            [nonSelectedStrokeColor]="drawOption.nonSelectedStrokeColor"
            [nonSelectedFillColor]="drawOption.nonSelectedFillColor"
            [nonSelectedTextColor]="drawOption.nonSelectedTextColor"
            [selectedStrokeColor]="drawOption.selectedStrokeColor"
            [selectedFillColor]="drawOption.selectedFillColor"
            [selectedTextColor]="drawOption.selectedTextColor"
            [placeholderFillColor]="drawOption.placeholderFillColor"
            [placeholderStrokeColor]="drawOption.placeholderStrokeColor"
            [placeholderTextColor]="drawOption.placeholderTextColor"
            [selectionPlaceholderFillColor]="drawOption.selectionPlaceholderFillColor"
            [selectionPlaceholderStrokeColor]="drawOption.selectionPlaceholderStrokeColor"
            [selectionPlaceholderTextColor]="drawOption.selectionPlaceholderTextColor"
            [optionType]="drawOption.optionType"
            (valueChanged)="onValueChange($event)"></single-number-picker>
        }
      </div>
    }
    @if (error !== '' && error !== undefined) {
      <ul class="parsley-errors-list filled">
        <li class="parsley-required">{{ error }}</li>
      </ul>
    }
  `,
  styleUrls: ['display-selected-line.scss'],
  standalone: false,
})
export class DisplaySelectedLineComponent {
  @Input() drawOption: DrawOptionInstanceDTO;

  @Input() selections: Array<BetSlipPickedDTO>;

  @Input() readonly: boolean;

  @Input() error: string;

  @Output() valueChanged = new EventEmitter<BetSlipPickedDTO>();

  @ViewChildren(SingleNumberPickerComponent) singleNumberPickers: SingleNumberPickerComponent[];

  constructor(public changeDetectorRef: ChangeDetectorRef) {}

  doError(error: any) {
    this.error = error.error;
    //        this.singleNumberPickers.forEach((singleNumberPicker: SingleNumberPickerComponent) => {
    //            singleNumberPicker.doError(error);
    //        });
  }

  refresh(pick: BetSlipPickedDTO) {
    // find the number picker that has changed and refresh
    this.singleNumberPickers.forEach((singleNumberPicker: SingleNumberPickerComponent) => {
      singleNumberPicker.refresh(pick);
    });
    this.changeDetectorRef.detectChanges();
  }

  onValueChange(change: BetSlipPickedDTO) {
    //        this.valueChanged.emit({drawOptionId: this.drawOption.id, value: change.value, id: change.id});
    this.valueChanged.emit(change);
  }
}
